import Vue from 'vue'
import Vant, { Locale,Toast } from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)
Vue.use(Toast);